import { createActionsHook } from "react-redux-actions-hook";
import { CentralArizonaActionType } from "./constants";
import { api } from "api/common";
import { setToastMessage } from "components/app/actions";
import {
  ALL_ENTITLMENTS_URL,
  PRIORITY_POOL_ENTITLMENTS_URL,
  DIFFERENCE_ENTITY_ENTITLMENTS_URL,
} from "api/constants";

export const toggleAboutDrawer = () => {
  return { type: CentralArizonaActionType.TOGGLE_ABOUT };
};

export const setChart = (chart) => {
  return { type: CentralArizonaActionType.SET_CHART, chart };
};

export const setEntitlements = (entitlements) => {
  return { type: CentralArizonaActionType.SET_ENTITLEMENTS, entitlements };
};

export const setScenario = (scenario) => {
  return { type: CentralArizonaActionType.SET_SCENARIO, scenario };
};

export const setPriorityEntitlements = (priority_entitlements) => {
  return {
    type: CentralArizonaActionType.SET_PRIORITY_ENTITLEMENTS,
    priority_entitlements,
  };
};

export const setEntitlementDifference = (entitlement_difference) => {
  return {
    type: CentralArizonaActionType.SET_ENTITLEMENT_DIFFERENCE,
    entitlement_difference,
  };
};

export const loadEntitlementDifference = () => {
  return (dispatch) => {
    api(
      `${DIFFERENCE_ENTITY_ENTITLMENTS_URL}`,
      {
        method: "GET",
      },
      dispatch
    )
      .then((response) => {
        dispatch(setEntitlementDifference(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

export const loadEntitlements = () => {
  return (dispatch) => {
    api(
      `${ALL_ENTITLMENTS_URL}`,
      {
        method: "GET",
      },
      dispatch
    )
      .then((response) => {
        dispatch(setEntitlements(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

export const loadPriorityEntitlements = () => {
  return (dispatch) => {
    api(
      `${PRIORITY_POOL_ENTITLMENTS_URL}`,
      {
        method: "GET",
      },
      dispatch
    )
      .then((response) => {
        dispatch(setPriorityEntitlements(response.data.rows));
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Unable to fetch topics",
            type: "error",
          })
        );
      });
  };
};

export default createActionsHook({
  toggleAboutDrawer,
  setChart,
  setEntitlements,
  loadEntitlements,
  setScenario,
  loadPriorityEntitlements,
  loadEntitlementDifference,
});
